<template>
  <div class="barra-cont">
    <div 
      class="barra-porcentaje"
      :class="{ 'barra-disabled': isDisabled }"
      :style="{
        '--valor-actual': isDisabled ? 100 : actual
      }"
    ></div>

    <div 
      v-show="!isDisabled && deseada > 0"
      class="barra-wrapper"
      :style="{
        '--valor-deseado': deseada
      }"
    ></div>

    <span 
      v-if="!isDisabled"
      class="etiqueta"
    >
      {{ actual }}%
    </span>
  </div>
</template>


<script>
export default {
  name: "BarraRenderer",
  props: ["value", "data", "colDef"],

  computed: {
    actual() {
      // console.log("actual: ",this.params.value)
      return this.params.value;
    },
    deseada() {
      const campo = this.params.colDef.cellRendererParams.deseadaField;
      
      // console.log("deseada: ",this.params.data[campo])
      return this.params.data[campo];
    },
    isDisabled() {
      return Number(this.params.data.n) < 5;
    }
  }
};
</script>

<style scoped>

.barra-cont{
  position: relative;
  width: 100%;
  height: 26px;
  top: 10px;

}


.barra-porcentaje {
  position: absolute;
  
  height: 100%;
  background: #D972A366;
  border-radius: 2px;
  width: calc(var(--valor-actual) * 1%);
}

.barra-wrapper{
  position: relative;
  width: 100%;
  height: 26px;
  top: 0px;

}

/* Línea deseada */
.barra-wrapper::after {
  content: "";
  position: absolute;
  top: 0px;
  bottom: 0px;
  left: calc(var(--valor-deseado) * 1%);
  width: 0;
  border-left: 2px dotted #660099;
}

.etiqueta {
  position: absolute;
  left: 4px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 12px;
  font-weight: 600;
  color: #444;
}
.barra-disabled {
  background: #eeeff1 !important; /* gris claro */
}
</style>



// WEBPACK FOOTER //
// src/components/cultura/sections/results/BarraRenderer.vue